import { useLocalStore } from "@store/useLocalStore";
import useSWR from "swr";

export const useParticulier = (url = null) => {

    const token = useLocalStore((state) => state.user.token);

    const fetcher = async (url) => {
        if (!url) return;

        const baseConfig = {
            headers: { 'Authorization': `Bearer ${token}` },
        };

        try {
            const response = await fetch(url, baseConfig);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('An error occurred:', error.message);
            throw error;
        }
    };

    const { data, error, isValidating } = useSWR(url, fetcher, {
        revalidateOnFocus: true,
        shouldRetryOnError: false,
        refreshInterval: 10000
    });
    const isLoading = !data && !error && isValidating;

    return [data, error, isLoading];
};